export default {
    state: {
        superBom: null,
    },
    actions: {
        async fetchSuperBom(ctx, bomId) {
            const toastWaitId = this._vm.$toast("Loading ...",{timeout: 60000,})
            const requestParams = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
            };
            const res = await fetch("/api/superbom/" + bomId + "/", requestParams);
            const superBom = await res.json();
            if (res.ok) {
                ctx.commit('updateSuperBom', superBom)
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.success("Success")
            }
            else {
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.error("Error:" + superBom['error'], {timeout: 5000})
            }
        },
        async fetchUpdateSuperBom(ctx, superBom) {
            const toastWaitId = this._vm.$toast("Wait until changes are saved",{timeout: 60000,})
            const jsonUpdateSuperBom = JSON.stringify(superBom)
            const requestUpdateBomComponent = {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                    'credentials': "same-origin",
                },
                body: jsonUpdateSuperBom
            };
            console.log('jsonUpdateSuperBom')
            console.log(jsonUpdateSuperBom)
            const resUpdateSuperBom = await fetch("/api/superbom/" +
                superBom.id + "/", requestUpdateBomComponent)
            const res = await resUpdateSuperBom.json();
            if (resUpdateSuperBom.ok) {
                ctx.commit('updateSuperBom', superBom)
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.success("Success")
            }
            else {
                this._vm.$toast.dismiss(toastWaitId)
                this._vm.$toast.error("Error:" + res['error'], {timeout: 5000})
            }
        }
    },
    mutations: {
        updateSuperBom(state, superBom) {
            state.superBom = superBom
        },
    },
    getters: {
        superBom(state) {
            return state.superBom
        },
    }
}